import { CreativeOSFeatures } from '@/_shared/subscriptionPlans'
import { ChartLine, CheckWaves, Layout, Store } from '@mynaui/icons-react'
import { FlameIcon } from 'lucide-react'
import { useState } from 'react'
import AccessControl from '../AccessControl'
import SearchDialogBrandsTab from '../SearchDialogBrandsTab'
import SearchDialogExpertsTab from '../SearchDialogExpertsTab'
import SearchDialogInspirationTab from '../SearchDialogInspirationTab'
import SearchDialogNewTemplatesTab from '../SearchDialogNewTemplatesTab'
import SearchDialogPopularTab from '../SearchDialogPopularTab'
import SearchDialogTemplateSection from '../SearchDialogTemplatesSection'
import TypingSearchViewCreatives from '../TypingSearchView'
import { CustomLightBulb } from '../shadcn/customLightBulb'
import { ScrollArea } from '../shadcn/scroll-area'
import { SidebarMenuButton } from '../shadcn/sidebar'
import { LockTagSmall } from './LockTag'

const AgenticSearchBarCreatives = ({
  searchTerm,
  debouncedSearchTerm,
  setDebouncedSearchTerm,
}: {
  searchTerm: string
  debouncedSearchTerm: string
  setDebouncedSearchTerm: (text: string) => void
}) => {
  const sidebarOptions = {
    nav: [
      { name: 'Popular', icon: ChartLine },
      { name: 'Templates', icon: Layout },
      { name: 'Inspiration', icon: CustomLightBulb },
      { name: 'Brands', icon: Store },
      { name: 'Experts', icon: CheckWaves },
      { name: 'New', icon: FlameIcon },
    ],
  }
  const [subSection, setSubSection] = useState<string>(sidebarOptions.nav[0].name)

  return debouncedSearchTerm ? (
    <TypingSearchViewCreatives searchTerm={searchTerm} debouncedSearchTerm={debouncedSearchTerm} />
  ) : (
    <div className="flex flex-col h-full lg:flex-row gap-2.5 w-full pb-5 flex-1">
      {/* Sidebar */}
      <div className="w-full lg:max-w-48 lg:block hidden">
        <div className="flex flex-row flex-wrap lg:flex-nowrap lg:flex-col gap-2 w-full">
          {sidebarOptions.nav.map((item) => (
            <AccessControl
              feature={
                item.name === 'Brands'
                  ? CreativeOSFeatures.SHOW_SEARCH_BRANDS_BUTTON
                  : item.name == 'Experts'
                    ? CreativeOSFeatures.SHOW_SEARCH_EXPERTS_BUTTON
                    : undefined
              }
              FeatureUnlocked={
                <SidebarMenuButton
                  key={item.name}
                  isActive={item.name === subSection}
                  onClick={() => setSubSection(item.name)}
                  className={`w-fit lg:w-full ${
                    item.name === 'Brands' || item.name == 'Experts' ? 'hidden lg:flex' : ''
                  }`}
                >
                  <item.icon />
                  <span className="w-full">{item.name}</span>
                </SidebarMenuButton>
              }
              FeatureLocked={
                <SidebarMenuButton
                  key={item.name}
                  className={`opacity-50 ${item.name === 'Brands' || item.name == 'Experts' ? 'hidden lg:flex' : ''}`}
                >
                  <item.icon />
                  <span className="w-full">{item.name}</span>
                  <LockTagSmall />
                </SidebarMenuButton>
              }
            />
          ))}
        </div>
      </div>

      <ScrollArea type="always" className="w-full flex-1 max-h-[75svh] lg:max-h-[85svh] pb-10">
        <div className="w-full block lg:hidden mb-5">
          <div className="flex flex-row flex-wrap lg:flex-nowrap lg:flex-col gap-2 w-full">
            {sidebarOptions.nav.map((item) => (
              <AccessControl
                feature={
                  item.name === 'Brands'
                    ? CreativeOSFeatures.SHOW_SEARCH_BRANDS_BUTTON
                    : item.name == 'Experts'
                      ? CreativeOSFeatures.SHOW_SEARCH_EXPERTS_BUTTON
                      : undefined
                }
                FeatureUnlocked={
                  <SidebarMenuButton
                    key={item.name}
                    isActive={item.name === subSection}
                    onClick={() => setSubSection(item.name)}
                    className={`w-fit lg:w-full ${
                      item.name === 'Brands' || item.name == 'Experts' ? 'hidden lg:flex' : ''
                    }`}
                  >
                    <item.icon />
                    <span className="w-full">{item.name}</span>
                  </SidebarMenuButton>
                }
                FeatureLocked={
                  <SidebarMenuButton
                    key={item.name}
                    className={`opacity-50 ${item.name === 'Brands' || item.name == 'Experts' ? 'hidden lg:flex' : ''}`}
                  >
                    <item.icon />
                    <span className="w-full">{item.name}</span>
                    <LockTagSmall />
                  </SidebarMenuButton>
                }
              />
            ))}
          </div>
        </div>
        {subSection === 'Popular' ? (
          <SearchDialogPopularTab searchItem={setDebouncedSearchTerm} />
        ) : subSection === 'Templates' ? (
          <SearchDialogTemplateSection />
        ) : subSection === 'Inspiration' ? (
          <SearchDialogInspirationTab />
        ) : subSection === 'Brands' ? (
          <SearchDialogBrandsTab />
        ) : subSection === 'Experts' ? (
          <SearchDialogExpertsTab />
        ) : subSection === 'New' ? (
          <SearchDialogNewTemplatesTab />
        ) : null}
      </ScrollArea>
    </div>
  )
}

export default AgenticSearchBarCreatives
